var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "./Spinner";
var FULL_SCREEN_CLASS = "h-screen w-screen flex";
export var FullScreen = function () { return (_jsx("div", __assign({ className: FULL_SCREEN_CLASS }, { children: _jsx(Spinner, { size: "4x", className: "m-auto" }, void 0) }), void 0)); };
